import { render } from "./HumanComputerInteractionView.vue?vue&type=template&id=5197d895&scoped=true"
const script = {}

import "./HumanComputerInteractionView.vue?vue&type=style&index=0&id=5197d895&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5197d895"]])

export default __exports__